import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Attachment } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Attachment';
/**
 * @class NCAttachment
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCAttachment
 * @label 附件
 *
 */
class NCAttachment extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
         * @title 区域编码
         * @description 组件标识
         */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title 禁止修改
         * @description 禁止修改
         */
        disableModify: PropTypes.bool,
        /**
         * @title 附件信息
         * @description 附件信息
         */
        fieldValue: PropTypes.string,
    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <Attachment {...this.props} />
        )
    }
}

export default NCAttachment;
